var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer3Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3000 610",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-3",
    serifId: "layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-and-car-2",
    serifId: "house and car 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2674.52,115.636c-0.934,-2.859 -3.602,-4.793 -6.61,-4.793c-3.009,-0 -5.676,1.934 -6.611,4.793c-12.46,37.209 -38.181,118.939 -38.181,159.594c0,33.301 20.071,60.336 44.792,60.336c24.721,0 44.791,-27.035 44.791,-60.336c0,-40.655 -25.721,-122.385 -38.181,-159.594Z",
    style: {
      fill: "#36783e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2765.59,161.394c-0.817,-3.034 -3.568,-5.142 -6.71,-5.142c-3.142,-0 -5.893,2.108 -6.71,5.142c-7.716,26.825 -19.332,71.099 -19.332,94.518c0,21.764 11.669,39.435 26.042,39.435c14.373,-0 26.042,-17.671 26.042,-39.435c-0,-23.419 -11.616,-67.693 -19.332,-94.518Z",
    style: {
      fill: "#36783e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2467.35,241.791c-0.806,-2.532 -3.158,-4.252 -5.816,-4.252c-2.657,-0 -5.009,1.719 -5.816,4.252c-9.329,28.269 -26.603,84.454 -26.603,112.927c0,24.212 14.527,43.869 32.419,43.869c17.893,-0 32.419,-19.657 32.419,-43.869c0,-28.473 -17.274,-84.658 -26.603,-112.927Z",
    style: {
      fill: "#36783e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2491.56,233.091l35.052,-77.717l101.459,78.09l-0.847,102.102l-135.585,0l-0.079,-102.475Z",
    style: {
      fill: "#ffe8a5"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2491.56,233.091l35.052,-77.717l101.459,78.09l-0.847,102.102l-135.585,0l-0.079,-102.475Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2500.37,235.289c0,-0.184 0.036,-0.366 0.106,-0.536c1.515,-3.679 18.812,-45.676 23.601,-57.303c0.211,-0.512 0.705,-0.849 1.258,-0.858c0.553,-0.01 1.059,0.311 1.286,0.815c5.218,11.547 24.185,53.521 25.905,57.327c0.082,0.182 0.125,0.38 0.125,0.58c-0,5.733 -0,90.881 -0,102.911c-0,0.778 -0.631,1.409 -1.409,1.409c-7.433,-0 -42.03,-0 -49.463,-0c-0.778,-0 -1.409,-0.631 -1.409,-1.409c0,-12.048 0,-97.428 0,-102.936Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.76
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2533.15,335.566c1.68,0 3.042,-1.361 3.042,-3.041c-0,-9.382 -0,-37.801 -0,-47.182c-0,-1.68 -1.362,-3.042 -3.042,-3.042c-3.628,0 -9.657,0 -13.286,0c-1.68,0 -3.041,1.362 -3.041,3.042c-0,9.381 -0,37.8 -0,47.182c-0,1.68 1.361,3.041 3.041,3.041c3.629,0 9.658,0 13.286,0Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2521.79,141.794c-0.749,0.003 -1.426,0.444 -1.731,1.128c-4.159,9.321 -32.953,73.849 -39.205,87.861c-0.263,0.589 -0.21,1.272 0.141,1.813c0.351,0.541 0.953,0.868 1.598,0.868c2.541,0 6.091,0 7.943,0c0.752,0 1.433,-0.442 1.74,-1.129c4.276,-9.583 34.341,-76.961 34.341,-76.961c0,-0 28.683,64.279 34.003,76.2c0.513,1.15 1.654,1.89 2.912,1.89c10.461,0 57.622,0 73.07,0c1.081,0 2.088,-0.547 2.676,-1.453c0.588,-0.907 0.677,-2.049 0.237,-3.036c-7.424,-16.637 -33.195,-74.391 -38.204,-85.616c-0.515,-1.154 -1.662,-1.895 -2.926,-1.89c-11.544,0.049 -67.564,0.286 -76.595,0.325Z",
    style: {
      fill: "#037f6e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2554.59,99.254c1.164,2.016 3.315,3.258 5.643,3.258c2.328,-0 4.479,-1.242 5.643,-3.258c9.631,-15.944 28.211,-48.847 28.211,-65.4c0,-18.684 -15.169,-33.854 -33.854,-33.854c-18.685,0 -33.854,15.17 -33.854,33.854c-0,16.553 18.58,49.456 28.211,65.4Z",
    style: {
      fill: "#037f6e"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2554.59,99.254c1.164,2.016 3.315,3.258 5.643,3.258c2.328,-0 4.479,-1.242 5.643,-3.258c9.631,-15.944 28.211,-48.847 28.211,-65.4c0,-18.684 -15.169,-33.854 -33.854,-33.854c-18.685,0 -33.854,15.17 -33.854,33.854c-0,16.553 18.58,49.456 28.211,65.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2545.94,28.112c-3.474,3.473 -3.474,9.105 -0,12.579c3.474,3.472 9.105,3.472 12.579,-0l6.194,-6.194c0.632,-0.633 1.655,-0.633 2.287,-0c0.631,0.63 0.631,1.655 0,2.287l-4.453,4.453c3.495,2.917 8.701,2.734 11.981,-0.546c3.474,-3.474 3.474,-9.106 0,-12.579c-3.472,-3.474 -9.105,-3.474 -12.579,-0l-6.194,6.194c-0.631,0.631 -1.655,0.631 -2.287,0c-0.631,-0.632 -0.631,-1.655 -0,-2.287l4.453,-4.454c-3.495,-2.916 -8.701,-2.734 -11.981,0.547Zm14.295,-2.825c-4.764,-4.192 -12.031,-4.013 -16.583,0.537c-4.735,4.738 -4.735,12.417 0,17.154c4.552,4.55 11.819,4.728 16.583,0.536c4.764,4.192 12.031,4.014 16.581,-0.536c4.735,-4.737 4.735,-12.416 -0,-17.154c-4.55,-4.55 -11.817,-4.729 -16.581,-0.537Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2379.05,284.719c-4.798,14.691 -17.734,28.812 -31.442,36.047c-10.707,5.65 -21.909,7.171 -29.93,0.93c-0.736,-0.584 -1.808,-0.461 -2.392,0.275c-0.585,0.736 -0.461,1.808 0.274,2.392c8.943,7.247 21.663,6.183 33.914,0.026c14.849,-7.464 28.934,-22.399 34.391,-38.044c0.448,-1.329 -0.266,-2.771 -1.595,-3.22c-1.328,-0.449 -2.771,0.266 -3.22,1.594Z",
    style: {
      fill: "#383128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386.39,277.834c0,-1.302 -0.517,-2.552 -1.439,-3.473c-0.921,-0.922 -2.17,-1.439 -3.473,-1.439c-0.002,-0 -0.004,-0 -0.006,-0c-1.303,-0 -2.552,0.517 -3.474,1.439c-0.921,0.921 -1.438,2.171 -1.438,3.473c-0,19.073 -0,87.159 -0,87.159l9.83,0c0,0 0,-68.086 0,-87.159Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2386.39,277.834c0,-1.302 -0.517,-2.552 -1.439,-3.473c-0.921,-0.922 -2.17,-1.439 -3.473,-1.439c-0.002,-0 -0.004,-0 -0.006,-0c-1.303,-0 -2.552,0.517 -3.474,1.439c-0.921,0.921 -1.438,2.171 -1.438,3.473c-0,19.073 -0,87.159 -0,87.159l9.83,0c0,0 0,-68.086 0,-87.159Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2376.56,
    y: 263.091,
    width: 9.831,
    height: 24.577,
    style: {
      fill: "#20f58f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2160.44,334.538c7.555,-0.456 14.05,5.169 14.496,12.554c0.446,7.385 -5.325,13.751 -12.88,14.207c-7.555,0.456 -14.051,-5.169 -14.497,-12.554c-0.446,-7.384 5.326,-13.75 12.881,-14.207Z",
    style: {
      fill: "#037f6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2272.05,330.094c8.397,-0.507 15.617,5.745 16.113,13.953c0.496,8.209 -5.919,15.285 -14.317,15.792c-8.397,0.507 -15.617,-5.745 -16.113,-13.954c-0.496,-8.208 5.919,-15.284 14.317,-15.791Z",
    style: {
      fill: "#037f6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331.67,346.85c0.077,1.784 -0.569,3.523 -1.791,4.825c-1.223,1.301 -2.918,2.054 -4.704,2.088c-29.714,0.571 -147.487,2.832 -161.864,3.108c-0.958,0.018 -1.917,-0.043 -2.866,-0.183c-2.655,-0.392 -8.582,-1.266 -14.027,-2.069c-6.227,-0.919 -10.569,-6.659 -9.758,-12.901c0,-0.001 0.001,-0.003 0.001,-0.004c1.073,-8.254 7.095,-15.006 15.172,-17.012l37.495,-9.31c0.682,-0.17 1.333,-0.447 1.929,-0.821c2.184,-1.373 8.064,-5.068 14.467,-9.091c14.248,-8.954 30.581,-14.047 47.394,-14.78c-0,-0 0,-0 0,-0c15.954,-0.695 31.833,2.57 46.217,9.506c10.217,4.927 21.363,10.301 27.088,13.061c2.384,1.15 3.944,3.517 4.059,6.163c0.288,6.652 0.845,19.504 1.188,27.42Z",
    style: {
      fill: "#ffe8a5"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2331.67,346.85c0.077,1.784 -0.569,3.523 -1.791,4.825c-1.223,1.301 -2.918,2.054 -4.704,2.088c-29.714,0.571 -147.487,2.832 -161.864,3.108c-0.958,0.018 -1.917,-0.043 -2.866,-0.183c-2.655,-0.392 -8.582,-1.266 -14.027,-2.069c-6.227,-0.919 -10.569,-6.659 -9.758,-12.901c0,-0.001 0.001,-0.003 0.001,-0.004c1.073,-8.254 7.095,-15.006 15.172,-17.012l37.495,-9.31c0.682,-0.17 1.333,-0.447 1.929,-0.821c2.184,-1.373 8.064,-5.068 14.467,-9.091c14.248,-8.954 30.581,-14.047 47.394,-14.78c-0,-0 0,-0 0,-0c15.954,-0.695 31.833,2.57 46.217,9.506c10.217,4.927 21.363,10.301 27.088,13.061c2.384,1.15 3.944,3.517 4.059,6.163c0.288,6.652 0.845,19.504 1.188,27.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2300.05,331.036c10.205,2.359 16.617,12.374 14.31,22.349c-2.307,9.975 -12.464,16.157 -22.669,13.797c-10.205,-2.36 -16.617,-12.374 -14.31,-22.349c2.307,-9.975 12.464,-16.157 22.669,-13.797Z",
    style: {
      fill: "#ffcf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198.34,331.554c10.204,2.36 16.617,12.374 14.31,22.349c-2.307,9.975 -12.465,16.158 -22.67,13.798c-10.204,-2.36 -16.616,-12.374 -14.31,-22.349c2.307,-9.975 12.465,-16.158 22.67,-13.798Z",
    style: {
      fill: "#ffcf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140.39,340.586c-0.464,1.633 -0.221,3.386 0.669,4.832c0.89,1.447 2.345,2.453 4.012,2.776c4.28,0.827 9.714,1.878 13.175,2.547c2.068,0.4 4.172,-0.494 5.321,-2.259c2.049,-3.148 5.335,-8.199 7.717,-11.86c1.928,-2.962 4.597,-5.368 7.743,-6.978c5.006,-2.561 12.775,-6.536 17.555,-8.981c0.471,-0.241 0.716,-0.774 0.592,-1.289c-0.123,-0.514 -0.584,-0.877 -1.113,-0.878c-3.896,-0.004 -8.987,-0.01 -10.348,-0.011c-0.231,-0.001 -0.461,0.027 -0.685,0.083c-2.48,0.616 -18.128,4.5 -29.429,7.306c-7.34,1.822 -13.143,7.435 -15.208,14.71c-0,0.001 -0.001,0.001 -0.001,0.002Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.87
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2220.86,317.332c-0.168,0.009 -0.327,-0.08 -0.408,-0.228c-0.081,-0.147 -0.071,-0.329 0.027,-0.466c0.49,-0.688 1.292,-1.816 2.286,-3.214c8.907,-12.521 23.68,-19.513 39.01,-18.465c0.001,-0 0.002,-0 0.003,-0c8.399,0.574 16.632,2.619 24.323,6.042c5.297,2.357 11.488,5.111 16.496,7.34c1.05,0.467 1.643,1.594 1.434,2.725c-0.21,1.13 -1.167,1.97 -2.315,2.03c-22.289,1.168 -73.419,3.846 -80.856,4.236Z",
    style: {
      fill: "#037f6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224.79,300.954c0.181,-0.216 0.198,-0.526 0.04,-0.76c-0.157,-0.234 -0.451,-0.335 -0.719,-0.247c-9.967,3.337 -20.086,8.794 -26.743,14.804c-0.186,0.173 -0.249,0.44 -0.162,0.678c0.087,0.238 0.309,0.401 0.562,0.413c3.473,0.165 11.936,0.567 13.667,0.649c0.197,0.009 0.387,-0.074 0.514,-0.225c1.383,-1.649 9.527,-11.361 12.841,-15.312Z",
    style: {
      fill: "#037f6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.26,334.755c8.397,-0.507 15.617,5.745 16.113,13.954c0.496,8.208 -5.919,15.284 -14.317,15.791c-8.397,0.507 -15.617,-5.745 -16.113,-13.953c-0.496,-8.209 5.919,-15.285 14.317,-15.792Z",
    style: {
      fill: "#037f6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294.97,334.236c8.398,-0.507 15.618,5.746 16.114,13.954c0.495,8.208 -5.92,15.284 -14.317,15.792c-8.398,0.507 -15.618,-5.746 -16.114,-13.954c-0.495,-8.208 5.92,-15.284 14.317,-15.792Z",
    style: {
      fill: "#037f6e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2716.14,67.917c-0.091,-2.045 -1.73,-3.681 -3.776,-3.768c-2.045,-0.087 -3.817,1.405 -4.08,3.435c-6.891,49.437 -17.497,131.441 -17.497,168.129c0,33.741 6.263,59.634 15.815,59.634c9.553,-0 15.816,-24.393 15.816,-58.134c-0,-36.698 -3.806,-119.419 -6.278,-169.296Z",
    style: {
      fill: "#36783e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-3",
    serifId: "trees 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081,224.415c-0.584,-2.147 -2.533,-3.637 -4.758,-3.638c-2.225,0 -4.174,1.491 -4.758,3.638c-9.435,34.058 -29.617,111.37 -29.617,149.613c0,30.98 15.403,56.132 34.375,56.132c18.972,-0 34.375,-25.152 34.375,-56.132c0,-38.243 -20.181,-115.555 -29.617,-149.613Z",
    style: {
      fill: "#638e50"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "trees-2",
    serifId: "trees 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177.51,346.553c17.876,0.994 15.11,-31.313 -6.295,-33.866c-13.725,-1.636 -12.84,6.327 -21.127,6.29c-10.627,-0.047 -5.515,-18.714 -26.401,-19.271c-23.789,-0.634 -31.294,29.495 -21.831,40.373c5.128,5.894 8.635,14.037 15.473,14.629c8.215,0.711 16.455,1.113 24.653,1.987c13.423,1.429 13.862,-11.347 35.528,-10.142Z",
    style: {
      fill: "#638e50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M996.431,344.362c-0,-1.993 -1.616,-3.609 -3.609,-3.609c-7.868,-0 -26.65,-0 -36.513,-0c-1.3,0 -2.499,-0.698 -3.14,-1.829c-0.641,-1.131 -0.625,-2.519 0.043,-3.634c8.498,-14.134 17.815,-26.749 28.768,-36.333c1.163,-0.963 1.598,-2.553 1.086,-3.974c-0.512,-1.421 -1.86,-2.368 -3.371,-2.368c-5.331,-0.027 -11.561,-0.027 -15.802,-0.027c-1.167,0 -2.262,-0.564 -2.94,-1.514c-0.677,-0.951 -0.853,-2.171 -0.472,-3.274c4.949,-14.067 12.017,-26.9 23.691,-37.054c1.139,-0.963 1.556,-2.534 1.043,-3.935c-0.512,-1.4 -1.845,-2.331 -3.336,-2.331c-1.687,-0.057 -3.38,-0.057 -4.919,-0.057c-1.293,0.001 -2.488,-0.691 -3.131,-1.813c-0.644,-1.122 -0.638,-2.502 0.016,-3.618c9.088,-15.447 19.284,-28.542 31.206,-37.982c1.319,-1.025 3.17,-1.009 4.471,0.038c13.315,10.812 22.486,23.791 28.479,38.433c0.442,1.108 0.306,2.364 -0.363,3.351c-0.669,0.988 -1.784,1.58 -2.978,1.58c-1.922,0.011 -4.171,0.011 -6.383,0.011c-1.503,0.001 -2.848,0.933 -3.377,2.34c-0.528,1.407 -0.13,2.994 1.001,3.984c11.828,10.489 19.601,23.039 24.36,37.11c0.36,1.095 0.173,2.297 -0.503,3.231c-0.676,0.934 -1.759,1.487 -2.912,1.487c-4.075,0.013 -10.037,0.013 -15.264,0.013c-1.536,0.001 -2.904,0.974 -3.408,2.426c-0.504,1.452 -0.033,3.063 1.173,4.015c13.309,10.586 22.428,23.019 28.948,36.586c0.524,1.114 0.441,2.419 -0.22,3.458c-0.66,1.04 -1.806,1.669 -3.037,1.669c-9.251,0.011 -27.504,0.011 -35.248,0.011c-1.993,-0 -3.608,1.616 -3.608,3.609c-0,11.19 -0,44.555 -0,44.555l-19.751,0c-0,0 -0,-33.365 -0,-44.555Z",
    style: {
      fill: "#638e50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "mountains-2",
    serifId: "mountains 2",
    d: "M0.002,397.791c443.073,100.529 661.658,62.644 1089.48,-47.446c443.68,-114.17 819.116,31.642 1221.99,5.652c328.264,-21.176 377.227,-117.833 688.527,-132.16l-0,385.452l-3000,0.189l0.002,-211.687Z",
    style: {
      fill: "url(#_Linear5)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mountains-21",
    serifId: "mountains 2",
    d: "M0.002,397.791c443.073,100.529 661.658,62.644 1089.48,-47.446c443.68,-114.17 819.116,31.642 1221.99,5.652c328.264,-21.176 377.227,-117.833 688.527,-132.16l-0,385.452l-3000,0.189l0.002,-211.687Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2505.83,331.705c-37.104,12.49 -82.723,14.526 -41.776,43.471c11.209,7.923 32.427,20.26 -2.781,31.508c-81.764,26.121 -128.773,31.87 -138.259,41.811c-14.141,14.818 51.43,21.981 28.274,63.759c-14.462,26.092 -164.146,42.11 -251.569,44.007c15.652,-6.605 34.05,-18.968 34.05,-18.968c60.908,-6.719 180.965,-10.909 186.999,-31.732c9.252,-31.926 -52.807,-56.962 -18.856,-73.253c50.998,-24.471 188.851,-23.806 138.826,-59.605c-28.2,-20.181 -18.37,-29.924 53.263,-40.909l11.829,-0.089Z",
    style: {
      fill: "#ffe4b9",
      fillOpacity: 0.42
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.09167,613.609,14.3925,0.0959719,1745.83,170.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b6a33",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffdd8e",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer3Day);
export default __webpack_public_path__ + "static/media/layer3-day.b7769bae44fc095598ec47b60f6897fd.svg";
export { ForwardRef as ReactComponent };